var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.266 12.7886C22.0217 12.7886 22.6344 13.4013 22.6344 14.157C22.6344 14.8587 22.1061 15.4371 21.4256 15.5161L21.266 15.5253H5.41388L9.91858 20.0311C10.4118 20.5243 10.4498 21.3005 10.0324 21.8373L9.91858 21.9662C9.42532 22.4595 8.64916 22.4974 8.11237 22.08L7.98347 21.9662L1.1418 15.1245C0.317276 14.3 0.839999 12.9156 1.95387 12.7968L2.10936 12.7886H21.266ZM20.7336 0.760578L20.8625 0.874409L27.7042 7.71608C28.5287 8.5406 28.006 9.92496 26.8921 10.0438L26.7366 10.052H7.57995C6.82424 10.052 6.21161 9.43934 6.21161 8.68363C6.21161 7.9819 6.73985 7.40355 7.42037 7.32451L7.57995 7.3153H23.4321L18.9274 2.80952C18.4341 2.31626 18.3962 1.5401 18.8136 1.00332L18.9274 0.874409C19.4207 0.381146 20.1968 0.343203 20.7336 0.760578Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon1.1a68d3fd47075a6a19b2a08f586d89ef.svg";
export { ForwardRef as ReactComponent };